// 방송 리소스 카탈로그(음악/효과음/배경 lottie).
// SSOT는 DB(resource_music/resource_sound_effect/resource_lottie) — ResourceApi로 1회 로드 후 모듈 캐시.
// 아래 FALLBACK_* 상수는 DB 비응답 시 graceful 용도로만 보존(과거 하드코딩 목록).
// 소비처는 get*()를 동기 호출하므로, 데이터 사용 전 ensureLoaded()를 await 해야 최신 DB값을 받는다.
import ResourceApi from "@/api/ResourceApi";

const FALLBACK_BACKGROUND_LOTTIES = [
  { label: "파티폭죽", fileName: "Animation - 1705904323766.json" },
  { label: "파티폭죽 굵은선", fileName: "Animation - 1712812265501.json" },
  { label: "파티폭죽 별별", fileName: "Animation - 1712812387135.json" },
  { label: "파티폭죽 색종이", fileName: "Animation - 1712812373495.json" },
  { label: "별톡톡터지기", fileName: "Animation - 1707292860613.json" },
  { label: "물음표", fileName: "Animation - 1712812542772.json" },
  { label: "물음표 주황", fileName: "Animation - 1712813064845.json" },
  { label: "큰 물음표 파랑", fileName: "Animation - 1712813349428.json" },
  { label: "큰 물음표 분홍", fileName: "Animation - 1712813417197.json" },
  { label: "퀴즈 물음표", fileName: "Animation - 1712813546900.json" },
  { label: "비옴", fileName: "Animation - 1712814087871.json" },
  { label: "파티폭죽 위로", fileName: "Animation - 1712812157228.json" },
  { label: "파티반짝이", fileName: "Animation - 1712811740281.json" },
  { label: "파티반짝이 보라", fileName: "Animation - 1712811191176.json" },
  { label: "폭죽놀이", fileName: "Animation - 1707089586279.json" },
  { label: "하트보글", fileName: "Animation - 1705108205940.json" },
  { label: "하트나비", fileName: "Animation - 1712751746284.json" },
  { label: "보라보라 버블", fileName: "Animation - 1712810247862.json" },
  { label: "하늘하늘 버블", fileName: "Animation - 1712810566604.json" },
  { label: "상큼한 버블", fileName: "Animation - 1712810619976.json" },
  { label: "할로윈", fileName: "background.json" },
  { label: "할로윈2", fileName: "background1.json" },
  { label: "이글이글", fileName: "Animation - 1707292771651.json" },
  { label: "불꽃", fileName: "Animation - 1705109414451_Fire.json" },
  { label: "조명", fileName: "Animation - 1707293395298.json" },
  { label: "강렬한 집중선", fileName: "Animation - 1710578134280.json" },
  { label: "집중선 회색", fileName: "Animation - 1712814353386.json" },
  { label: "집중선 빨강", fileName: "Animation - 1710641101706.json" },
  { label: "집중선 보라", fileName: "Animation - 1712814429037.json" },
  { label: "물차오르기", fileName: "Animation - 1707089885173.json" },
];

const FALLBACK_EFFECT_SOUNDS = [
  { label: "꽉", fileName: "quack.wav" },
  { label: "파워업", fileName: "powerup.wav" },
  { label: "짜잔", fileName: "짜잔(퍼거션).mp3" },
  { label: "또잉", fileName: "doing.wav" },
  { label: "팝팝", fileName: "pop.wav" },
  { label: "두둥탁", fileName: "dudungtack.mp3" },
  { label: "슬라이드", fileName: "slide.wav" },
  { label: "띠링", fileName: "화면전환효과음_01.wav" },
  { label: "띠로롱", fileName: "화면전환효과음_02.wav" },
  { label: "맑은소리", fileName: "화면전환효과음_03.wav" },
  { label: "맑은 벨", fileName: "화면전환효과음_04.wav" },
  { label: "밝은 알림음", fileName: "화면전환효과음_05.wav" },
  { label: "뽁", fileName: "화면전환효과음_09.wav" },
  { label: "물방울 똑", fileName: "화면전환효과음_10.wav" },
  { label: "꼬르륵", fileName: "화면전환효과음_11.wav" },
  { label: "샴페인 펑", fileName: "화면전환효과음_12.wav" },
  { label: "또잏", fileName: "화면전환효과음_18.wav" },
  { label: "폭죽", fileName: "화면전환효과음_21.wav" },
  { label: "띠링", fileName: "015_띠링.mp3" },
  { label: "웃음소리", fileName: "016. 웃음소리.mp3" },
  { label: "으악내눈", fileName: "017_으악내눈!.mp3" },
  { label: "슈퍼마리오", fileName: "031_슈퍼마리오.WAV" },
  { label: "뾰로롱", fileName: "036_뾰로롱.mp3" },
  { label: "삐", fileName: "039_삐.mp3" },
  { label: "방구", fileName: "bangoo.wav" },
  { label: "", fileName: "쨔쟌 내가 돌아왔다.mp3" },
  { label: "부팅음", fileName: "vista.wav" },
  { label: "종료음", fileName: "vistashutdown.wav" },
  { label: "예빈", fileName: "ye.mp4" },
  { label: "꽁꽁한강", fileName: "hanriver.mp4" },
];

const FALLBACK_MUSICS = [
  { label: "코카인", fileName: "kokain.mp3" },
  { label: "워싱시", fileName: "washingsi.mp3" },
  { label: "제로투", fileName: "zerotwo.mp3" },
  { label: "포케댄스", fileName: "pokedance.mp3" },
  { label: "축복 배경음", fileName: "119_축복 배경음.mp3" },
  { label: "그런데 말입니다", fileName: "117_그런데말입니다 배경음.mp3" },
];

const FALLBACK_LOTTIE_BG_CANVAS = [
  { label: "그래디언트", fileName: "Animation - 1710648129371.json" },
  { label: "산", fileName: "Animation - 1710648114723.json" },
  { label: "사막", fileName: "Animation - 1710648069013.json" },
  { label: "야간", fileName: "Animation - 1710648096508.json" },
  { label: "우주", fileName: "Animation - 1711758024696.json" },
  { label: "무지개", fileName: "Animation - 1710578079806.json" },
  { label: "뭉개구름", fileName: "Animation - 1712376103740.json" },
];

// DB row({label, file_name, ...}) → 소비처 기대 형태({label, fileName, durationMs})
const toItem = (r) => ({ label: r.label || "", fileName: r.file_name, durationMs: r.duration_ms ?? null });

const _cache = {
  musics: null,
  sounds: null,
  lottieBackground: null,
  lottieBgCanvas: null,
};
let _loadPromise = null;

export default class BroadCastResourceManager {
  // DB에서 리소스 메타 1회 로드(중복 호출 시 동일 프로미스 재사용). 실패 시 fallback 유지.
  static ensureLoaded() {
    if (_loadPromise) return _loadPromise;
    _loadPromise = (async () => {
      try {
        const [musics, sounds, lottie] = await Promise.all([
          ResourceApi.fetchMusic(),
          ResourceApi.fetchSoundEffect(),
          ResourceApi.fetchLottie(),
        ]);
        _cache.musics = musics.map(toItem);
        _cache.sounds = sounds.map(toItem);
        _cache.lottieBackground = lottie.filter((r) => r.category === "background").map(toItem);
        _cache.lottieBgCanvas = lottie.filter((r) => r.category === "background-canvas").map(toItem);
      } catch (e) {
        console.warn("[BroadCastResourceManager] DB 로드 실패 — fallback 사용", e);
      }
    })();
    return _loadPromise;
  }

  static getLottieBg() {
    return _cache.lottieBgCanvas || FALLBACK_LOTTIE_BG_CANVAS;
  }

  static getEffectBackground() {
    return _cache.lottieBackground || FALLBACK_BACKGROUND_LOTTIES;
  }

  static getAudioMusic() {
    return _cache.musics || FALLBACK_MUSICS;
  }

  static getAudioEffect() {
    return _cache.sounds || FALLBACK_EFFECT_SOUNDS;
  }
}
